import { FC } from "react";
import { cx } from "shared/utils";
import { SVGComponentProps } from "untitledui-js-base";

export const WithIcon = ({
  Icon,
  children,
  className,
  iconClassName
}: {
  Icon: FC<SVGComponentProps>;
  children: React.ReactNode;
  className?: string;
  iconClassName?: string;
}) => (
  <div className={cx("flex items-center text-sm -translate-x-2", className)}>
    <Icon className={cx("w-5 h-5 mr-2 stroke-content-100", iconClassName)} />
    {children}
  </div>
);
